import React from "react";

import PhoneDesktop from "./Desktop";

const Phone = () => {
  return <PhoneDesktop />;
};

export default Phone;
